export default "/assets/72f70336b48b5978b5a87fe65d3826c2.png";